import { useEffect, useState } from "react";
import { fetchJudgeCalibration, type JudgeCalibrationRun } from "@/services/adminModelCurrency";
import CalibrationTable from "./CalibrationTable";
import LabelingPanel from "./LabelingPanel";
import { describeApiError } from "./helpers";

const JudgeCalibrationTab = () => {
  const [runs, setRuns] = useState<JudgeCalibrationRun[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchJudgeCalibration()
      .then(data => setRuns(data.runs))
      .catch(err => setError(describeApiError(err)));
  }, []);

  return (
    <div className="space-y-8">
      <section className="space-y-2">
        <h2 className="text-base font-semibold">Label saved chats</h2>
        <p className="text-sm text-muted-foreground">
          Score real answers yourself. These scores are the answer key we use to check whether an AI
          judge can be trusted. Judge scores are never shown here, so yours stay unbiased.
        </p>
        <LabelingPanel />
      </section>
      <section className="space-y-2">
        <h2 className="text-base font-semibold">Latest judge comparison</h2>
        {error ? (
          <p role="alert" className="text-sm text-destructive">
            Couldn't load the comparison: {error}
          </p>
        ) : runs ? (
          <CalibrationTable runs={runs} />
        ) : (
          <p className="text-sm text-muted-foreground">Loading…</p>
        )}
      </section>
    </div>
  );
};

export default JudgeCalibrationTab;
